import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { CourseProgressSummary, UnitProgress } from '../data/student-report';
import { Course } from '../data/course';

@Component({
  selector: 'app-student-progress-report-strand',
  templateUrl: './student-progress-report-strand.component.html',
  styleUrls: ['./student-progress-report-strand.component.scss']
})

// this component contains one specific strand, rendering it similarly to the app-student-progress-report-kinder component
export class StudentProgressReportStrandComponent extends BaseComponent implements OnInit {
  @Input() strand: CourseProgressSummary;
  @Input() studentId: number;
  
  selectedUnitNumber: number;

  ngOnInit(): void {
    this.selectedUnitNumber = this.highestCompletedUnitInCurrentCourse || 101;
  }

  get highestCompletedUnitInCurrentCourse(): number {
    var highestUnit = this.strand.Units.slice().reverse().find(u => u.CompletedActivityCount > 0);
    return highestUnit ? highestUnit.UnitNumber : 0;
  }

  selectUnit(unit: UnitProgress, initial = false): void {
    if (unit && (initial || unit.CompletedActivityCount !== 0)) {
      this.selectedUnitNumber = unit.UnitNumber;
    }
  }

  getUnitCircleClass(unit: UnitProgress) {
    const classes = ['unit-circle'];
    if (unit.CompletedActivityCount === 0) {
      classes.push('unstarted');
    }
    else if (unit.UnitNumber < this.highestCompletedUnitInCurrentCourse || unit.UnitTested === true) {
      classes.push('completed');
    }
    else {
      classes.push('in-progress');
    }

    if (unit.CompletedActivityCount > 0) {
      classes.push('pointer');
    }

    if (unit.UnitNumber === this.selectedUnitNumber) {
      classes.push('selected');
    }
    return classes;
  }
}
